import swal from "sweetalert2";
import withReactContent from "sweetalert2-react-content";

const MySwal = withReactContent(swal);
const Toast = MySwal.mixin({
  customClass: {
    container: "toast-container2",
    popup: "toast-container",
  },
  toast: true,
  position: "top",
  showConfirmButton: false,
  timer: 3000,
  timerProgressBar: true,
  showCloseButton: true,
  didOpen: (toast) => {
    toast.addEventListener("mouseenter", swal.stopTimer);
    toast.addEventListener("mouseleave", swal.resumeTimer);
  },
});

export function CustomToast(icon, title, width, body, position) {
  return Toast.fire({
    title: title ?? "",
    text: body ?? '',
    icon,
    width: width ?? 350,
    position: position ?? 'top'
  });
}
